import React from "react";

const CustomButtonIcon = (props) => {
  return (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      fill="none"
      style={{
        verticalAlign: "bottom",
      }}
      {...props}
    >
      <path
        d="M4 6C2.34315 6 1 4.65685 1 3C1 1.34315 2.34315 0 4 0H11C12.6569 0 14 1.34315 14 3C14 4.65685 12.6569 6 11 6H9V3.5C9 2.11929 7.88071 1 6.5 1C5.11929 1 4 2.11929 4 3.5V6Z"
        fill="#cccccc"
      />
      <path
        d="M6.5 2C5.67157 2 5 2.67157 5 3.5V8.05001C3.85888 8.28164 3 9.29052 3 10.5C3 12.9853 5.01472 15 7.5 15H8C10.7614 15 13 12.7614 13 10V9.14706C13 7.96127 12.0387 7 10.8529 7H8V3.5C8 2.67157 7.32843 2 6.5 2Z"
        fill="#cccccc"
      />
    </svg>
  );
};

export default CustomButtonIcon;
